import {
  GET_LEGALPERMISSION,
  GET_LEGALPERMISSION_SUCCESS,
  GET_LEGALPERMISSION_FAIL,
  DELETE_LEGALPERMISSION,
  DELETE_LEGALPERMISSION_SUCCESS,
  DELETE_LEGALPERMISSION_FAIL,
  UPDATE_LEGALPERMISSION,
  UPDATE_LEGALPERMISSION_SUCCESS,
  UPDATE_LEGALPERMISSION_FAIL,
  ADD_NEW_LEGALPERMISSION,
  ADD_LEGALPERMISSION_SUCCESS,
  ADD_LEGALPERMISSION_FAIL,
  LEGALPERMISSION_LOADING,
  LEGALPERMISSION_RESET
} from "./actionType";

export const resetLegalPermissionState = (actionType) => ({
  type: LEGALPERMISSION_RESET,
  payload: { actionType },
});

export const getLegalPermissionSuccess = (actionType, data) => ({
  type: GET_LEGALPERMISSION_SUCCESS,
  payload: { actionType, data },
});

export const getLegalPermissionFail = (actionType, error) => ({
  type: GET_LEGALPERMISSION_FAIL,
  payload: { actionType, error },
});

export const getLegalPermission = data => ({
  type: GET_LEGALPERMISSION,
  payload: data,
});

export const getLegalPermissionLoading = () => ({
  type: LEGALPERMISSION_LOADING
});

export const deleteLegalPermission = data => ({
  type: DELETE_LEGALPERMISSION,
  payload: data,
});

export const deleteLegalPermissionSuccess = data => ({
  type: DELETE_LEGALPERMISSION_SUCCESS,
  payload: data,
});

export const deleteLegalPermissionFail = error => ({
  type: DELETE_LEGALPERMISSION_FAIL,
  payload: error,
});

export const updateLegalPermission = data => ({
  type: UPDATE_LEGALPERMISSION,
  payload: data,
});

export const updateLegalPermissionFail = error => ({
  type: UPDATE_LEGALPERMISSION_FAIL,
  payload: error,
});

export const updateLegalPermissionSuccess = data => ({
  type: UPDATE_LEGALPERMISSION_SUCCESS,
  payload: data,
});

export const addNewLegalPermission = data => ({
  type: ADD_NEW_LEGALPERMISSION,
  payload: data,
});

export const addLegalPermissionSuccess = data => ({
  type: ADD_LEGALPERMISSION_SUCCESS,
  payload: data,
});

export const addLegalPermissionFail = error => ({
  type: ADD_LEGALPERMISSION_FAIL,
  payload: error,
});